// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__+5O0P","blockMsg":"Message_blockMsg__8pMb3","avatar":"Message_avatar__grXm2","avatarBg":"Message_avatarBg__-TCCT","nameAuthor":"Message_nameAuthor__a9ZcS"};